import errorHandle from '../../../utils/errorHandle';
import { orgCustomTripBookingFun, orgTripBookedFun } from '../../../api/orgTripAPI';

export default async function fetchTripDateTable(setTripDateDetails, setLoading) {
    const dateId = window.location.pathname.split('/')[4];

    setLoading(true);
    try {
        const table = await orgTripBookedFun(dateId);
        setTripDateDetails(table.data);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
}

export const fetchCustomTripDateTable = async (setTripDateDetails, setLoading) => {
    const packId = window.location.pathname.split('/')[4];
    const startDate = window.location.pathname.split('/')[5];
    setLoading(true);
    try {
        const table = await orgCustomTripBookingFun(packId, startDate);
        setTripDateDetails(table.data);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};
